import classNames from 'classnames';
import React from 'react';
import styled from 'styled-components';
import { formatNumberWithCommas } from 'Utils/UtilityFunctions';
import {
  boxShadow, maxWidth, retina, secondaryFont, wMBold,
} from 'Utils/utilsStyle';

const Wrapper = styled.div`
  padding: 60px 15px;
  border-radius: 12px;
  text-align: center;
  height: 100%;
  box-shadow: ${boxShadow};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &.inOneLine{
    padding: 60px 0px;
  }
  @media all and (max-width: ${maxWidth}) , ${retina} {
    padding: 30px 15px;
  }
`;

const StatesTitle = styled.h6`
  font-family: ${secondaryFont};
  font-weight: ${wMBold};
  font-size: 14px;
  padding: 0px 15px;
  line-height: 16px;
  letter-spacing: -0.37px;
`;

const StatesNumber = styled.h6`
  font-size: 37px;
  font-family: ${secondaryFont};
  line-height: 26px;
  margin-top: 10px;
  color: #001824;
    @media all and (max-width: ${maxWidth}) , ${retina} {
     font-size: 28px;
    }
  span.hrs {
    font-size: 21px;
    font-family: ${secondaryFont};
  }
`;

type Props = {
  statesTitle?: string,
  statesNumber?: string,
  isTimeSpent?: boolean,
  oneliner?: boolean,
} | typeof defaultProps;

const defaultProps = {
  statesTitle: 'Rank in Team',
  statesNumber: 'N/A',
  isTimeSpent: false,
  oneliner: false,
};

const StatesWidget = function StatesWidget(props: Props) {
  const {
    statesTitle, statesNumber, isTimeSpent, oneliner,
  } = props;
  const numberValue = Number(statesNumber);
  const isNumber = !Number.isNaN(numberValue);

  const formattedScoreCount = isNumber ? formatNumberWithCommas(numberValue) : statesNumber;

  return (
    <Wrapper className={classNames({ inOneLine: oneliner })}>
      <StatesTitle>{statesTitle}</StatesTitle>
      <StatesNumber className="stateItemNum">
        {formattedScoreCount}
        {/* {isTimeSpent && <span className="hrs">hrs</span>} */}
      </StatesNumber>
    </Wrapper>
  );
};

StatesWidget.defaultProps = defaultProps;
export default StatesWidget;
